// import Vue from 'vue';
import Vuex from 'vuex';
import global from './store/global.store';
import ui from './store/ui.store';
import resources from '@/modules/resources/resources.store';
import relations from '@/modules/relations/relations.store';
import tags from '@/modules/tags/tags.store';
import user from './store/user.store';

export default new Vuex.Store({
  modules: {
    global,
    ui,
    relations,
    resources,
    tags,
    user,
  },
});
